import React from "react";
import Icon from "./Icon";

const SKELETON_ROWS = 9;

/** Loading skeleton, load-failure and no-results states for the product list. */
export default function CatalogStateBox({ kind, onRetry, onReset }) {
  if (kind === "loading") {
    return (
      <div className="ac-tbl-wrap" aria-busy="true" aria-label="Loading products">
        {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
          <div key={i} className="ac-skrow">
            <span className="sk" style={{ width: 16 }} />
            <span className="sk" style={{ width: 180 + (i % 3) * 40 }} />
            <span className="sk" style={{ width: 60 }} />
            <span className="sk" style={{ width: 90 }} />
            <span className="sk pill" style={{ width: 110 }} />
            <span className="sk pill" style={{ width: 36 }} />
          </div>
        ))}
      </div>
    );
  }
  if (kind === "error") {
    return (
      <div className="ac-tbl-wrap ac-state" role="alert">
        <span className="ic err"><Icon n="alertCircle" s={24} /></span>
        <h4>Could not load the AHA catalog</h4>
        <p>The catalog request failed. No changes were made. Check your connection and try again.</p>
        <div className="row"><button type="button" className="ac-btn" onClick={onRetry}><Icon n="refresh" s={14} />Retry</button></div>
      </div>
    );
  }
  return (
    <div className="ac-tbl-wrap ac-state">
      <span className="ic"><Icon n="search" s={24} /></span>
      <h4>No products match these filters</h4>
      <p>Try a different name or product number, or remove a filter. Product numbers use the format NN-NNNN.</p>
      <div className="row"><button type="button" className="ac-sbtn" onClick={onReset}>Clear all filters</button></div>
    </div>
  );
}
